import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { I18nService } from '../../services/i18n.service';

export interface Testimonial {
  text: string;
  author: string;
  isVisible: boolean;
}

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, OnDestroy {
  testimonials: Testimonial[] = [];
  showAll = false;
  private languageSubscription: Subscription = new Subscription();

  constructor(public i18n: I18nService) {}

  ngOnInit() {
    this.loadTestimonials();

    // Підписуємося на зміну мови
    this.languageSubscription = this.i18n.currentLanguage$.subscribe(() => {
      this.loadTestimonials();
    });
  }

  ngOnDestroy() {
    this.languageSubscription.unsubscribe();
  }

  loadTestimonials() {
    this.testimonials = [
      {
        text: this.i18n.getTranslation('testimonials.item1_text'),
        author: this.i18n.getTranslation('testimonials.item1_author'),
        isVisible: true
      },
      {
        text: this.i18n.getTranslation('testimonials.item2_text'),
        author: this.i18n.getTranslation('testimonials.item2_author'),
        isVisible: false
      },
      {
        text: this.i18n.getTranslation('testimonials.item3_text'),
        author: this.i18n.getTranslation('testimonials.item3_author'),
        isVisible: false
      }
    ];
  }

  toggleTestimonials() {
    this.showAll = !this.showAll;
    this.testimonials.forEach((testimonial, index) => {
      if (index > 0) {
        testimonial.isVisible = this.showAll;
      }
    });
  }

  get visibleTestimonials() {
    return this.testimonials.filter(t => t.isVisible);
  }

  get buttonText() {
    return this.showAll
      ? (this.i18n.getTranslation('nav.home') === 'Home' ? 'Show Less' : 'Приховати')
      : this.i18n.getTranslation('testimonials.button');
  }
}
